import type { FilterState } from './filterTypes';

export type BedsFilterValue = {
  selected: string;
  max: number | null;
};

export function filterStateToBeds(bedrooms: FilterState['bedrooms']): BedsFilterValue {
  if (bedrooms.min === null) return { selected: 'any', max: null };
  return { selected: String(bedrooms.min), max: bedrooms.max ?? null };
}

export function bedsToFilterState(beds: BedsFilterValue): FilterState['bedrooms'] {
  if (beds.selected === 'any') return { min: null, max: null };
  const num = parseInt(beds.selected, 10);
  if (num === 0) return { min: 0, max: 0 };
  return { min: num, max: beds.max ?? null };
}
